import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopandharpurakkalkot() {



    const cardData = {

keyword: "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking services for spiritual and family pilgrimage tours. We provide comfortable and well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, and Mini Bus with professional chauffeurs experienced in long-distance devotional routes. With 24x7 availability, transparent pricing, doorstep pickup and drop in Mumbai, flexible one-way and round-trip options, and safe driving on highway routes, we ensure a smooth and peaceful pilgrimage journey covering Maharashtra’s most sacred temples.",

topPlaces: [
    {
        title: "Pandharpur Vitthal Rukmini Temple",
        description:
            "Pandharpur is one of Maharashtra’s most important pilgrimage centers dedicated to Lord Vitthal. Devotees from Mumbai travel here throughout the year for darshan, especially during Ashadhi Ekadashi, making it a highly visited spiritual destination."
    },
    {
        title: "Akkalkot Shri Swami Samarth Temple",
        description:
            "Akkalkot is a revered spiritual destination associated with Shri Swami Samarth Maharaj. It attracts thousands of devotees seeking blessings and peace, and is a key stop in Maharashtra’s pilgrimage circuit."
    },
    {
        title: "Tuljapur Bhavani Temple",
        description:
            "Tuljapur is famous for the Tulja Bhavani Temple, one of the most powerful Shakti Peeths in Maharashtra. It is a must-visit spiritual destination for devotees traveling from Mumbai."
    },
    {
        title: "Solapur City Stopover",
        description:
            "Solapur is a major connecting city on this pilgrimage route offering rest, food, and travel breaks. It is commonly included in multi-temple cab tour itineraries for comfort and convenience."
    },
    {
        title: "Pandharpur Chandrabhaga River Ghats",
        description:
            "The Chandrabhaga River ghats in Pandharpur are considered sacred by devotees. Pilgrims often take a holy dip here before visiting the Vitthal temple."
    },
    {
        title: "Tuljapur Yatra Route Scenic Drive",
        description:
            "The highway route from Mumbai to Tuljapur offers smooth travel through Maharashtra’s countryside, making the journey peaceful and suitable for family pilgrimage trips."
    },
    {
        title: "Akkalkot Spiritual Surroundings",
        description:
            "Akkalkot is surrounded by a calm and devotional atmosphere, making it ideal for meditation, temple visits, and spiritual experiences during the pilgrimage tour."
    },
    {
        title: "Pandharpur Wari Pilgrimage Path",
        description:
            "Pandharpur is famous for the Wari pilgrimage tradition, where lakhs of devotees walk in devotion. Cab services provide comfortable travel support for families and elderly pilgrims."
    },
    {
        title: "Tuljapur Fort & Heritage Area",
        description:
            "The region around Tuljapur also includes historical and cultural sites, adding value to spiritual tours with heritage exploration opportunities."
    },
    {
        title: "Akkalkot Nearby Temples Circuit",
        description:
            "Around Akkalkot, several small temples and spiritual sites can be visited, making it a complete devotional travel experience for pilgrims from Mumbai."
    }
],



services: [
{
name: "Mumbai to Pandharpur Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Pandharpur Cab Booking service for comfortable and reliable pilgrimage travel to the holy town of Pandharpur, home to Lord Vitthal and Rukmini temple. Our service is designed for families, devotees, and group travellers seeking a peaceful and well-organized spiritual journey. We provide well-maintained vehicles including Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and Mini Bus options depending on group size. With professional chauffeurs experienced in long-distance and temple routes, we ensure safe travel, timely arrival for darshan, flexible pickup and drop service, transparent pricing, and 24x7 support. Whether it is a one-day visit, weekend pilgrimage, or extended religious tour, our service ensures a smooth, devotional, and stress-free travel experience."
},
{
name: "Mumbai to Akkalkot Cab",
description: "Mumbai Airport Cab provides Mumbai to Akkalkot Cab service for devotees travelling to the sacred town of Akkalkot, known for Shri Swami Samarth Maharaj temple. Our pilgrimage cab service ensures comfortable and safe transportation for families and groups visiting for darshan and spiritual visits. We offer clean, air-conditioned vehicles, experienced chauffeurs familiar with temple routes, flexible travel schedules, and doorstep pickup and drop service. With transparent pricing and reliable support, we make your spiritual journey peaceful and well-organized."
},
{
name: "Mumbai to Tuljapur Cab",
description: "Book Mumbai to Tuljapur Cab with Mumbai Airport Cab for convenient travel to Shri Tulja Bhavani Temple, one of Maharashtra’s most important Shakti Peeths. Our service is ideal for family pilgrimages, religious groups, and devotees seeking safe and comfortable travel. We provide spacious vehicles, professional drivers, luggage support, and flexible itinerary options. Whether it is a same-day darshan or overnight trip, we ensure timely travel, comfort, and a smooth devotional experience."
},
{
name: "Mumbai Pilgrimage Cab Service",
description: "Mumbai Airport Cab offers Mumbai Pilgrimage Cab Service for devotees travelling to major spiritual destinations across Maharashtra and India. Our service covers temple tours, yatras, and religious circuits with comfortable vehicles, experienced chauffeurs, and customized travel planning. We ensure safe highway travel, punctual pickups, flexible routes, and complete assistance for family and group pilgrimage journeys, making your spiritual travel meaningful and hassle-free."
},
{
name: "Pandharpur Taxi from Mumbai",
description: "Pandharpur Taxi from Mumbai service provides direct and comfortable transportation for devotees travelling to Vitthal Rukmini Temple. Mumbai Airport Cab ensures smooth long-distance travel with well-maintained vehicles, professional drivers, and flexible pickup options from any location in Mumbai. We focus on safety, comfort, and timely arrival so passengers can enjoy peaceful darshan without travel stress."
},
{
name: "Akkalkot Darshan Cab Mumbai",
description: "Akkalkot Darshan Cab Mumbai service is specially designed for devotees visiting Shri Swami Samarth Maharaj temple. Mumbai Airport Cab provides comfortable vehicles, experienced chauffeurs familiar with pilgrimage routes, and flexible travel plans for families and groups. We ensure safe travel, convenient pickup and drop service, and a peaceful spiritual journey experience."
},
{
name: "Tuljapur Bhavani Temple Cab",
description: "Tuljapur Bhavani Temple Cab service offers reliable transportation for devotees visiting Shri Tulja Bhavani Temple from Mumbai and nearby cities. Mumbai Airport Cab provides clean, air-conditioned vehicles, professional drivers, and customized travel schedules for family and group pilgrimage tours. We ensure timely darshan visits, safe highway travel, and comfortable journey experiences."
},
{
name: "Mumbai Religious Tour Cab",
description: "Mumbai Religious Tour Cab service provides complete transportation solutions for spiritual tours covering multiple temples and pilgrimage destinations across Maharashtra and India. Mumbai Airport Cab offers flexible itineraries, experienced chauffeurs, and comfortable vehicles for families and groups. We ensure smooth travel planning, safe journeys, and a peaceful devotional experience throughout the tour."
},
{
name: "Maharashtra Pilgrimage Cab Package",
description: "Maharashtra Pilgrimage Cab Package by Mumbai Airport Cab offers curated travel routes covering major religious destinations such as Pandharpur, Shirdi, Trimbakeshwar, Bhimashankar, Tuljapur, Akkalkot, and more. Our packages include comfortable vehicles, professional drivers, flexible scheduling, and customized itineraries. We ensure a complete spiritual travel experience with convenience, safety, and devotion."
},
{
name: "Pandharpur Vitthal Darshan Cab",
description: "Pandharpur Vitthal Darshan Cab service provides dedicated transportation for devotees visiting Lord Vitthal temple. Mumbai Airport Cab ensures comfortable travel with experienced drivers, clean vehicles, and flexible departure timings aligned with darshan schedules. We focus on providing a peaceful, organized, and safe pilgrimage journey."
},
{
name: "Akkalkot Swami Samarth Cab",
description: "Akkalkot Swami Samarth Cab service offers comfortable and reliable transportation for devotees visiting the sacred Swami Samarth Maharaj temple. Mumbai Airport Cab provides spacious vehicles, professional chauffeurs, and flexible travel arrangements for families and groups. We ensure safe travel, timely darshan, and a smooth spiritual experience."
},
{
name: "Tuljapur Temple Travel Cab",
description: "Tuljapur Temple Travel Cab service by Mumbai Airport Cab ensures convenient transportation for pilgrims visiting the Bhavani Mata temple. Our service includes comfortable vehicles, experienced drivers, and flexible travel plans suitable for families and religious groups. We prioritize safety, punctuality, and comfort for a stress-free pilgrimage journey."
},
{
name: "Mumbai Spiritual Tour Cab",
description: "Mumbai Spiritual Tour Cab service offers customized travel for spiritual seekers visiting temples, ashrams, and pilgrimage destinations across Maharashtra. Mumbai Airport Cab provides comfortable vehicles, knowledgeable drivers, and flexible itineraries to ensure a peaceful and meaningful travel experience for individuals and groups."
},
{
name: "Maharashtra Temple Tour Cab",
description: "Maharashtra Temple Tour Cab service provides organized transportation for multi-temple pilgrimage circuits across the state. Mumbai Airport Cab offers comfortable vehicles, professional chauffeurs, and customized tour planning for destinations like Pandharpur, Shirdi, Nashik, Tuljapur, Akkalkot, and more. We ensure smooth, safe, and devotional travel experiences."
},
{
name: "Mumbai Devotional Cab Service",
description: "Mumbai Devotional Cab Service is designed for pilgrims and families travelling to religious destinations for worship and spiritual journeys. Mumbai Airport Cab provides well-maintained vehicles, experienced drivers, and flexible travel schedules. We ensure safe, comfortable, and peaceful transportation for all devotional trips."
},
{
name: "Pilgrimage Tour Mumbai Cab",
description: "Pilgrimage Tour Mumbai Cab service offers complete travel solutions for religious journeys starting from Mumbai to major temples and spiritual destinations. Mumbai Airport Cab provides comfortable vehicles, customized itineraries, and professional chauffeurs to ensure a smooth and meaningful pilgrimage experience for families and groups."
},
{
name: "Mumbai Family Yatra Cab",
description: "Mumbai Family Yatra Cab service is ideal for families planning religious tours, temple visits, and spiritual journeys together. Mumbai Airport Cab provides spacious vehicles, safe drivers, flexible schedules, and comfortable seating to ensure a smooth and enjoyable pilgrimage experience for all family members."
}
],

tableData: [
["Mumbai to Pandharpur Cab Booking","Mumbai to Akkalkot Cab"],
["Mumbai to Tuljapur Cab","Mumbai Pilgrimage Cab Service"],
["Pandharpur Taxi from Mumbai","Akkalkot Darshan Cab Mumbai"],
["Tuljapur Bhavani Temple Cab","Mumbai Religious Tour Cab"],
["Maharashtra Pilgrimage Cab Package","Pandharpur Vitthal Darshan Cab"],
["Akkalkot Swami Samarth Cab","Tuljapur Temple Travel Cab"],
["Mumbai Spiritual Tour Cab","Maharashtra Temple Tour Cab"],
["Mumbai Devotional Cab Service","Pilgrimage Tour Mumbai Cab"],
["Mumbai Family Yatra Cab","Mumbai Pilgrimage Travel Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable cab services for devotees traveling from Mumbai to Pandharpur, Akkalkot, and Tuljapur with comfortable and hassle-free transportation."
    },
    {
        WhyChooseheading: "Complete Religious Tour Package",
        WhyChoosedescription: "Our cab service covers the sacred pilgrimage circuit of Shri Vitthal Rukmini Mandir Pandharpur, Shri Swami Samarth Maharaj Temple Akkalkot, and Tulja Bhavani Temple Tuljapur."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Pilgrimage Travel",
        WhyChoosedescription: "Travel peacefully with well-maintained vehicles designed to provide comfort during long-distance religious journeys across Maharashtra."
    },
    {
        WhyChooseheading: "Multiple Vehicle Options Available",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses according to group size and travel requirements."
    },
    {
        WhyChooseheading: "Customized Darshan and Tour Planning",
        WhyChoosedescription: "We provide flexible travel itineraries with options for multiple temple visits, overnight stays, and customized pilgrimage schedules."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our professional drivers are familiar with temple routes, highway travel, and important pilgrimage destinations across Maharashtra."
    },
    {
        WhyChooseheading: "Ideal for Families and Devotee Groups",
        WhyChoosedescription: "From individual devotees and families to religious groups and senior citizens, we provide suitable transportation for every pilgrimage requirement."
    }
]
};

const faqData = [
    {
        question: "Which temples are covered in the Mumbai to Pandharpur Akkalkot Tuljapur tour?",
        answer: "The tour generally covers Shri Vitthal Rukmini Mandir Pandharpur, Shri Swami Samarth Maharaj Temple Akkalkot, and Shri Tulja Bhavani Temple Tuljapur."
    },
    {
        question: "Can I customize the pilgrimage itinerary?",
        answer: "Yes, customers can customize the route, temple visits, overnight stays, and travel duration according to their requirements."
    },
    {
        question: "Which vehicle is suitable for this religious tour?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, Tempo Travellers, and Mini Buses are available based on passenger count."
    },
    {
        question: "Do you provide one-way and round-trip packages?",
        answer: "Yes, customers can choose one-way transfers, round trips, and complete pilgrimage tour packages."
    },
    {
        question: "Can senior citizens comfortably travel on this route?",
        answer: "Yes, we provide comfortable vehicles suitable for senior citizens, families, and devotees undertaking long-distance pilgrimage travel."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for group tours, bhajan mandals, and large family groups."
    },
    {
        question: "Can pickup be arranged from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for temple tours?",
        answer: "Yes, advance booking is highly recommended, especially during Ashadhi Ekadashi, Kartiki Ekadashi, weekends, and festival seasons."
    },
    {
        question: "Can additional temples be added to the route?",
        answer: "Yes, customers can include nearby religious destinations and temples as part of their customized pilgrimage itinerary."
    },
    {
        question: "How can I book a Mumbai to Pandharpur Akkalkot Tuljapur Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Suresh Wagh",
        feedback:
            "Our family completed the Pandharpur, Akkalkot, and Tuljapur pilgrimage comfortably. The vehicle was excellent and the driver was very helpful throughout the journey.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Kulkarni",
        feedback:
            "The entire religious tour was well organized and stress-free. Mumbai Airport Cabs provided a clean vehicle, punctual service, and a smooth travel experience for our group.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-pilgrimage-cab-pandharpur-akkalkot-tuljapur.jpg",
"description": "Book Mumbai to Pandharpur, Akkalkot, and Tuljapur cab service for pilgrimage and spiritual tours in Maharashtra. Mumbai Airport Cabs offers comfortable long-distance taxi service for temple visits including Vitthal Darshan, Swami Samarth Darshan, and Tuljapur Bhavani Temple with professional drivers and reliable travel packages.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-pandharpur-akkalkot-tuljapur-cab-booking"
}
};








    return (
        <div>


<Helmet>
  <title>Mumbai to Pandharpur Akkalkot Tuljapur Cab | Pilgrimage Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Pandharpur, Akkalkot, and Tuljapur cab for pilgrimage tours in Maharashtra. Comfortable temple travel packages with professional drivers and 24x7 outstation taxi service."
/>

<meta
 name="keywords"
 content="mumbai to pandharpur cab booking, mumbai to akkalkot cab, mumbai to tuljapur cab, mumbai pilgrimage cab service, pandharpur taxi from mumbai, akkalkot darshan cab mumbai, tuljapur bhavani temple cab, mumbai religious tour cab, maharashtra pilgrimage cab package, pandharpur vitthal darshan cab, akkalkot swami samarth cab, tuljapur temple travel cab, mumbai spiritual tour cab, maharashtra temple tour cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopandharpurakkalkot;